import {React} from "react";
import   "../pages/styles.css";



const PastEvents = () => {

     return (
<div style={{background:"#eceff3f6"}}>
      <div className={`boldFancyHeadFontCenter`} >
         Please bear with us as we are still gathering content for this page.
          
      </div>
     </div>
  )
};
   
export default PastEvents;